module.exports = __webpack_public_path__ + "media/images/emblems/Witterswil-blason-88effc0582421578826343553b0451ae.png";